import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from '@nuxtjs/composition-api';

type PublicPortfolioClientProps = {
  image?: string;
  title?: string;
  slug?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioClient',
  props: {
    image: { default: '' },
    title: { default: '' },
    slug: { default: '' }
  },
  setup(__props: any) {

const props = __props as { image: string, title: string, slug: string };



const hasError = ref(false);

const attrs = computed(() =>
  props.slug
    ? {
        href: `/salaries/company/${props.slug}/people/`,
      }
    : {},
);
const component = computed(() => (props.slug ? 'a' : 'div'));

return { __sfc: true,props, hasError, attrs, component }
}

})